import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "../svg.style";
export var Error = function(_param) /*#__PURE__*/ {
    var color = _param.color, height = _param.height, width = _param.width, shrinkable = _param.shrinkable, rest = _object_without_properties(_param, [
        "color",
        "height",
        "width",
        "shrinkable"
    ]);
    return _jsx(S.Svg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        height: height,
        width: width,
        viewBox: "0 0 24 24",
        shrinkable: shrinkable
    }, rest), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m21.634 17.045-7-12.964a3 3 0 0 0-5.265 0l-7 12.959A3 3 0 0 0 5 21.48h14a3 3 0 0 0 2.634-4.435zM11.5 7.983a.5.5 0 1 1 1 0v7.062a.5.5 0 1 1-1 0zm.5 10.125a.625.625 0 1 1 .44-.186.625.625 0 0 1-.44.182z",
            fill: color
        })
    }));
};
